import { Button } from 'react-bootstrap';

const AgencyInfoPanel = ({ agencyName, agencyEmail, username, canOverride, onOverrideAgency }) => {

  return (
    <div className="text-muted">
        <div><strong>Agency Information</strong>
        <Button hidden={!canOverride} variant="outline-secondary" type="button" size="sm" className="ms-3 float-end" onClick={onOverrideAgency}>Change</Button></div>
        <hr/>
        <strong>{agencyName || 'N/A'}</strong>
        <br/>
        {username || 'N/A'}
        <br/>
        {agencyEmail || 'N/A'}
    </div>
  );
};

export default AgencyInfoPanel;
